
import React, { useEffect, useMemo, useState } from "react";
import Header from "../../layout/header/Header";
import { Helmet } from "react-helmet";
import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import ThankYou from "../voucher-form/components/thank-you/ThankYou";
import PaymentStatus from "../voucher-form/components/thank-you/PaymentStatus";
import TransactionHistory from "../voucher-form/components/thank-you/TransactionHistory";
import AlertMessage from "../voucher-form/components/thank-you/AlertMessage";
import editIcon from "../../assets/icons/ic-solar_pen-bold.svg";
import RelandingPaymentStatus from "../voucher-form/components/thank-you/RelandingPaymentStatus";
import PreferentialAccordion from "../voucher-form/components/thank-you/PreferentialAccordion";
import VerifyOTPModal from "../voucher-form/components/thank-you/VerifyOTPModal";
import { BOOKING_STATUS, COMPARE_VALUE, EOIFormStatus, FORM_PHASE } from "../../config/constant";
import {
  getVoucherById,
  sendVoucherOTP,
  VerifyOTP,
  setEditPreviewApplicant,
  reSendVoucherOTP,
  BuyNewVoucher,
  setShowThankYouMessage,
  requestCancellations,
  getEOICampaignDetails,
  getMyVoucherList,
  setActiveStep,
  setResetData as setVoucherFormResetData,
} from "../voucher-form/voucher-form.slice";
import { useDispatch, useSelector } from "react-redux";
import SnackbarAlert from "../../shared-components/snackbar-alert/SnackbarAlert";
import { useParams, useHistory, useLocation } from "react-router-dom";
import "./VoucherThankyou.scss";
import ConfirmDialogWithComment from "../../shared-components/confirm-dialog-with-comment/ConfirmDialogWithComment";
import { useFormik } from "formik";
import * as yup from "yup";
import { formatIndianNumber } from "../voucher-form/components/common-functions/PaymentCommonFunctions";
import MyVouchers from "../voucher-form/components/thank-you/MyVouchers";
import { getCurrentFormPhase } from "../../utilis/common-funtions";
import { Description } from "@mui/icons-material";
import { getOppprtunityDetails, setResetData as setNewBookingFormResetData, clearEnquiryDetails } from "../new-booking-form/new-booking-form.slice";

const Thankyou = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [verifiedOTP, setVerifiedOTP] = useState(false);
  const [neededToVerifyOTP, setNeededToVerifyOTP] = useState(false);
  const dispatch = useDispatch();
  const { voucherId } = useParams();
  const history = useHistory();
  const location = useLocation();

  const formik = useFormik({
    initialValues: {
      selectedVoucher: "",
    },
    validationSchema: yup.object().shape({
      selectedVoucher: yup.string().notRequired(),
    }),
    onSubmit: (values) => {
      //  handleContinue();
    },
  });

  const {
    applicantData,
    showThankYouMessage,
    isUpgradePreferentialStep,
    myVoucherList,
  } = useSelector((state) => state.voucherForm);
  const oppId = applicantData?.opportunityId;
  const entity = getCurrentFormPhase(applicantData?.formPhase);
  const ALLOWED_STATUSES = [
  EOIFormStatus.MIS_REQUESTED_CHANGES,
  EOIFormStatus.MIS_UPDATED,
  EOIFormStatus.MIS_VERIFIED,
  EOIFormStatus.CRM_REQUESTED_CHANGES,
  EOIFormStatus.CRM_UPDATED,
  EOIFormStatus.CRM_VERIFIED,
  EOIFormStatus.UPGRADING,
  EOIFormStatus.UNVERIFIED
];

const PREVIEW_ALLOWED_STATUSES = [
  EOIFormStatus.ACTIVE,
  EOIFormStatus.UPGRADED,
  EOIFormStatus.CONVERTED,
  EOIFormStatus.CANCELLED_NOT_REALISED,
  EOIFormStatus.CANCEL_REQUESTED,
  EOIFormStatus.CANCEL_ACCEPTED,
  EOIFormStatus.CANCEL_APPROVED,
  EOIFormStatus.REFUND_INITIATED,
  EOIFormStatus.CANCELLED
];

  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [wrongOTP, setWrongOTP] = useState(0);
  const [isBlocked, setIsBlocked] = useState(false);
  const [modalErrorMsg, setModalErrorMsg] = useState("");
  const [localThankYou,setLocalThankYou] = useState(false)
   const [cancellationReqDialog, setCancellationReqDialog] = useState({
    open: false,
    id: null,
    reason: "",
  });
  // Show View & Edit button only when ?r=... is present
  const searchParams = new URLSearchParams(location.search);
  const showViewEditButton = ALLOWED_STATUSES.includes(applicantData?.voucherFormStatus)
  const showPreviewiewButton = PREVIEW_ALLOWED_STATUSES.includes(applicantData?.voucherFormStatus)

  const referralCode = searchParams.get("r"); 
  const showButtonCustOnly = !referralCode;
  const isCancelDisabled =
  applicantData?.voucherFormStatus === EOIFormStatus.CANCEL_REQUESTED ||
  applicantData?.voucherFormStatus === EOIFormStatus.CANCEL_ACCEPTED ||
  applicantData?.voucherFormStatus === EOIFormStatus.CANCEL_APPROVED ||
  applicantData?.voucherFormStatus === EOIFormStatus.REFUND_INITIATED ||
  applicantData?.voucherFormStatus === EOIFormStatus.CANCELLED;

  useEffect(() => {
    if (voucherId) {
      dispatch(setVoucherFormResetData());
      dispatch(setNewBookingFormResetData());
      (async () => {
        try {
          let url = `/${voucherId}`;
        if (referralCode) {
          url += `?r=${encodeURIComponent(referralCode)}`;
        }
         const res = await dispatch(getVoucherById(url)).unwrap();

         dispatch(getEOICampaignDetails({ campaignId: res?.campaignId || "" }));
          if (res?.toBeVerified) {
            setNeededToVerifyOTP(true);
            setIsModalOpen(true);
            dispatch(setShowThankYouMessage(false));
            
            const otpRes = await dispatch(
              sendVoucherOTP({ voucherId })
            ).unwrap();

            // ✅ after this log you can add your condition check
          } else {
            setNeededToVerifyOTP(false);
            setVerifiedOTP(true);
          }
        } catch (error) {
          console.error("Error fetching voucher or sending OTP:", error);
          setSnackbarConfig({
            open: true,
            message: error?.errors?.message || "Failed to send otp",
            severity: "error",
          });
          if (
            error?.errors?.message ===
            "Too many failed OTP attempts. Please try again later."
          ) {
            setIsBlocked(true);
            setModalErrorMsg(
              "Too many failed attempts. Please wait a while before trying again."
            );
          }

          setWrongOTP((prev) => prev + 1);
        }
      })();
    }
    if (voucherId) {
      dispatch(getMyVoucherList({ voucherId }));
    }
  }, [voucherId]);

  useEffect(()=>{
    if(formik?.values?.selectedVoucher){
      history.push(`/voucher-form/${formik?.values?.selectedVoucher}`)
    }
  },[formik?.values?.selectedVoucher])

 
  
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleVerifyOTP = async (otp) => {
    if (isBlocked) {
      setSnackbarConfig({
        open: true,
        message:
          "Too many failed attempts. Please try again later or resend OTP.",
        severity: "error",
      });
      return;
    }

    if (!otp || otp.length !== 6) {
      setSnackbarConfig({
        open: true,
        message: "Invalid OTP format!",
        severity: "error",
      });
      return;
    }

    try {
      const payload = { voucherId, otp };
      const res = await dispatch(VerifyOTP(payload)).unwrap();

      if (res?.verified) {
        setVerifiedOTP(true);
        setIsModalOpen(false);
        setWrongOTP(0); // reset counter
        setSnackbarConfig({
          open: true,
          message: res?.message || "OTP verified successfully!",
          severity: "success",
        });
      } else {
        // API responded but OTP is wrong
        const newCount = wrongOTP + 1;
        setWrongOTP(newCount);
        if (newCount === 5) {
          setModalErrorMsg(
            "You have entered an invalid OTP 5 times. Please try again later."
          );
        }
        if (newCount >= 5) {
          setIsBlocked(true);
          setSnackbarConfig({
            open: true,
            message:
              "You have exceeded maximum OTP attempts. Please resend OTP.",
            severity: "error",
          });
        } else {
          setSnackbarConfig({
            open: true,
            message: "Incorrect OTP. Attempts left: " + (5 - newCount),
            severity: "error",
          });
        }
      }
    } catch (error) {
      // API error handling
      setSnackbarConfig({
        open: true,
        message: error?.errors?.message || "OTP Verification Error!",
        severity: "error",
      });
      console.error("OTP Verification Error:", error);

      // also count as a failed attempt
      const newCount = wrongOTP + 1;
      setWrongOTP(newCount);
      if (newCount >= 5) {
        setIsBlocked(true);
        setSnackbarConfig({
          open: true,
          message: "You have exceeded maximum OTP attempts. Please resend OTP.",
          severity: "error",
        });
      }
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarConfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleResendOTP = async () => {
    try {
      const otpRes = await dispatch(reSendVoucherOTP({ voucherId })).unwrap();
      if (otpRes?.data?.success) {
        setSnackbarConfig({
          open: true,
          message: "OTP resent successfully!",
          severity: "success",
        });
      } else {
        setSnackbarConfig({
          open: true,
          message: otpRes?.data?.message || "Failed to resend OTP",
          severity: "error",
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const HandleBuyNewVoucher = async () => {
    try {
      const payload = { voucherId: applicantData?.id };
      const res = await dispatch(BuyNewVoucher(payload)).unwrap();
      setSnackbarConfig({
        open: true,
        message: "Voucher purchased successfully!",
        severity: "success",
      });
      if (res?.voucherFormUrl) {
        window.open(res.voucherFormUrl, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      console.error("Buy New Voucher Error:", error);
      setSnackbarConfig({
        open: true,
        message:
          error?.errors?.message ||
          "Something went wrong while buying voucher!",
        severity: "error",
      });
    }
  };

  useEffect(() => {
    if (showThankYouMessage) {
      setLocalThankYou(true)
      dispatch(setShowThankYouMessage(false));
    }
  }, []);

  useEffect(() => {
    if (
      applicantData?.voucherFormStatus === EOIFormStatus?.CREATED ||
      applicantData?.voucherFormStatus === EOIFormStatus?.IN_PROGRESS
    ) {
      history.push(`/voucher-form/${voucherId}`);
    }
  }, [applicantData]);

  useEffect(() => {
    const applicantMatchesCurrentVoucher = applicantData?.voucherId === voucherId;
    if (applicantMatchesCurrentVoucher) {
      if (oppId) {
        dispatch(getOppprtunityDetails(`/${oppId}`));
      } else {
        dispatch(clearEnquiryDetails());
      }
    }
  }, [oppId, dispatch, applicantData?.voucherId, voucherId]);

  const handleCancelRequest = () => {
      dispatch(
        requestCancellations({
          voucherId: applicantData?.voucherId,
          cancelReason: cancellationReqDialog?.reason,
        })
      )
        .unwrap() // gives direct access to fulfilled/rejected values
        .then((res) => {
          if (res.success) {
            setCancellationReqDialog({ open: false, id: null, reason: "" });
            setSnackbarConfig({
            open: true,
            message: 'Cancellation requested successfully',
            severity: "success",
          });
          dispatch(getVoucherById(`/${voucherId}`))
          }
        })
        .catch((err) => {
          console.error("Cancel failed:", err);
             setSnackbarConfig({
            open: true,
            message: err?.errors?.message || "Failed to send otp",
            severity: "error",
          });
        });
    
  };

  const MY_VOUCHERS_OPTIONS = useMemo(() => {
    return myVoucherList?.map(item => ({
      value: item.voucherId,
      name: item.uniqueReferenceId,
    })) || [];
  }, [myVoucherList]);

  return (
    <div className="thankyou-page">
      <Helmet>
        <title>Thank You - {applicantData?.formPhase  === FORM_PHASE.VOUCHER && !isUpgradePreferentialStep ?  "Voucher Form": "Expression of Interest Form"}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Header logo={COMPARE_VALUE?.Puravankara} isMenuOpen={false} />
      {verifiedOTP && (
        <Grid
          container
          spacing={0}
          sx={{
            p: 0,
            paddingLeft: {
              xs: "16px",
              sm: "16px",
              md: "16px",
              lg: "7%",
            },
            paddingRight: {
              xs: "16px",
              sm: "16px",
              md: "16px",
              lg: "7%",
            },
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              textAlign: {
                xs: "center",
                sm: "center",
                md: "center",
              },
              pt: {
                xs: "16px",
                sm: "30px",
                md: "36px",
              },
              pb: {
                xs: "16px",
                sm: "18px",
                md: "20px",
              },
            }}
          >
            <Typography
              sx={{
                color: "#1A407D",
                fontSize: {
                  xs: "20px",
                  sm: "20px",
                  md: "24px",
                },
                fontWeight: "700",
                lineHeight: {
                  xs: "28px",
                  sm: "32px",
                  md: "36px",
                },
                mb: {
                  xs: 0.5,
                  sm: 1,
                  md: 1,
                },
              }}
            >
              {localThankYou
                ? "Thank You"
                : applicantData?.isUpgradableToEOI &&
                  !localThankYou &&
                  verifiedOTP
                ? "Voucher Form - Upgrade to Preferential EOI"
                : !localThankYou &&
                  verifiedOTP &&
                  !applicantData.isUpgradableToEOI
                ? "My Voucher/EOI"
                : "Voucher Form"}
            </Typography>
          </Grid>
        </Grid>
      )}

      {verifiedOTP && (
        <Box
          sx={{
            borderRadius: "8px",
            border: "1px solid rgba(26, 64, 125, 0.30)",
            padding: {
              xs: "24px",
              sm: "24px",
              lg: "24px 24px 24px 24px",
            },
            marginLeft: {
              xs: "16px",
              sm: "16px",
              lg: "70px",
            },
            marginRight: {
              xs: "16px",
              sm: "16px",
              lg: "70px",
            },
            marginBottom: {
              xs: "50px",
              sm: "70px",
              lg: "70px",
            },
          }}
        >
          <Grid
            container
            spacing={2}
            alignItems="stretch"
            direction="row"
            wrap={{ xs: "wrap", sm: "nowrap" }}
            sx={{
              flexDirection: {
                xs: "column", // below 1000px → column
              },
              "@media (min-width:1001px)": {
                flexDirection: "row", // above 1000px → row
                flexWrap: "nowrap",
              },
            }} // prevent wrapping until 1000px
          >
            {/* Left Card */}
            <Grid
              item
              xs={12}
              sm
              md
              lg
              xl
              sx={{ flex: { xs: "1 1 100%", sm: "1 1 70%" } }} // 70% until 1000px
            >
              {verifiedOTP && !localThankYou ? (
                <RelandingPaymentStatus />
              ) : null}

              {localThankYou && <ThankYou />}
              {localThankYou && (!applicantData?.paidVoucherId  || !applicantData?.stdEoiId || !applicantData?.preEoiId) && (
                <AlertMessage
                  type="warning"
                  title={`${entity} ID Assignment Pending`}
                  message={`${entity} ID will be assigned once the complete amount of ₹${formatIndianNumber(applicantData?.paymentDetails?.amountPayable)} is received.`}
                  highlight={`₹${formatIndianNumber(applicantData?.paymentDetails?.amountPayable)} is received`}
                />
              )}
            </Grid>

            {/* Divider for desktop (vertical) */}
            <Grid
              item
              md="auto"
              sx={{
                display: { xs: "none", md: "flex" },
                justifyContent: "center",
                alignItems: "stretch",
              }}
            >
              <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
            </Grid>

            {/* Right Card */}
            <Grid
              item
              xs={12}
              sm
              md
              lg
              xl
              sx={{ flex: { xs: "1 1 100%", sm: "1 1 30%" } }} // 30% until 1000px
            >
              {MY_VOUCHERS_OPTIONS?.length > 0 && (
                <MyVouchers options={MY_VOUCHERS_OPTIONS} formik={formik} />
              )}

              {applicantData?.isUpgradableToEOI && <PreferentialAccordion />}
             {/* Need to uncomment when needed */}
             
              {oppId &&
                <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
                  <Button
                    variant="outlined"
                    startIcon={<Description />}
                    sx={{
                      fontWeight: 600,
                      fontSize: "16px",
                      color: "#1A407D",
                      borderColor: "#1A407D",
                      borderRadius: "8px",
                      "&:hover": {
                        borderColor: "#1A407D",
                        backgroundColor: "transparent",
                      },
                    }}
                    onClick={() => {
                      window.open(
                        `/booking-form/${oppId}`,
                        "_blank",
                        "noopener,noreferrer"
                      );
                    }}
                  >
                   {applicantData?.bookingStatus === BOOKING_STATUS.PENDING ? "Pre-fill Booking Form" : "View Booking Form"}
                  </Button>
                </Box>}

              {localThankYou && <PaymentStatus />}
              <TransactionHistory />
            </Grid>
          </Grid>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between", // Keep balanced layout
              alignItems: "center",
              mt: "30px",
              flexWrap: "wrap",
              gap: "20px",
            }}
          >
            <Box sx={{ display: "flex", gap: "20px", flexWrap: "wrap", }}>
              {showViewEditButton && (
                <Button
                  variant="outlined"
                  startIcon={<img src={editIcon} alt="edit-icon" />}
                  sx={{
                    border: "1px solid #D0D5DD",
                    color: "#1A407D",
                    textTransform: "none",
                    fontSize: "16px",
                    px: 2,
                    py: 1,
                    borderRadius: "8px",
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    dispatch(setActiveStep(0));
                    dispatch(setEditPreviewApplicant(true));
                    history.push(`/voucher-form/${voucherId}`);
                  }}
                >
                  View & Edit Form
                </Button>
              )}
              {showPreviewiewButton && <Button
                variant="outlined"
                sx={{
                  border: "1px solid #D0D5DD",
                  color: "#1A407D",
                  textTransform: "none",
                  fontSize: "16px",
                  px: 2,
                  py: 1,
                  borderRadius: "8px",
                  fontWeight: 600,
                }}
                onClick={() => {
                  window.open(`/voucher-preview/${voucherId}`, "_blank", "noopener,noreferrer");
                }}
              >
                Preview Form
              </Button>}

              </Box>
             { showButtonCustOnly && ( <Button
                variant="contained"
                onClick={HandleBuyNewVoucher}
                sx={{
                  backgroundColor: "#1A407D",
                  textTransform: "none",
                  fontSize: "16px",
                  px: 3,
                  py: 1,
                  borderRadius: "8px",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: "#1A407D",
                  },
                }}
              >
                Buy New {entity}
              </Button>)}
            
          </Box>
        </Box>
      )}

      <ConfirmDialogWithComment
        open={cancellationReqDialog.open}
        onClose={() => setCancellationReqDialog({ open: false, id: null, reason: '' })}
        title="Request Cancellation"
        confirmText="Are you sure you want to cancel Voucher/EOI?"
        textValue={cancellationReqDialog.reason}
        onTextChange={(e) =>
          setCancellationReqDialog((prev) => ({ ...prev, reason: e.target.value }))
        }
        placeholder="Enter reason for cancellation request"
        confirmBtnDisabled={cancellationReqDialog?.reason?.trim()?.length === 0}
        confirmBtnLabel="Yes, Cancel"
        onSubmit={()=>{handleCancelRequest()}}
      />
      {isModalOpen && <VerifyOTPModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onVerify={(otp) => handleVerifyOTP(otp)}
        isBlocked={wrongOTP >= 5 || isBlocked}
        handleResend={handleResendOTP}
        errorMessage={modalErrorMsg}
      />}
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </div>
  );
};

export default Thankyou;
